import { render, staticRenderFns } from "./ControlPanelConfiguration.vue?vue&type=template&id=8964365a&scoped=true"
import script from "./ControlPanelConfiguration.vue?vue&type=script&lang=js"
export * from "./ControlPanelConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8964365a",
  null
  
)

export default component.exports